'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024 from "./scala.-I-Array$package$-I-Array$.js";
var $p;
function $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__($thiz, typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations) {
  $thiz.wa = typeInfo;
  $thiz.mh = parameters;
  $thiz.w9 = annotations;
  return $thiz;
}
export { $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__ as $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__ };
/** @constructor */
function $c_Lmagnolia1_CaseClass() {
  this.wa = null;
  this.mh = null;
  this.w9 = null;
}
export { $c_Lmagnolia1_CaseClass as $c_Lmagnolia1_CaseClass };
$p = $c_Lmagnolia1_CaseClass.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CaseClass;
/** @constructor */
function $h_Lmagnolia1_CaseClass() {
}
export { $h_Lmagnolia1_CaseClass as $h_Lmagnolia1_CaseClass };
$h_Lmagnolia1_CaseClass.prototype = $p;
$p.b = (function() {
  return (((("CaseClass(" + this.wa.BB()) + ", ") + $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024.$m_s_IArray$package$IArray$().yg(this.mh), "", ",", "")) + ")");
});
